import React from 'react';
import { getDisplayName } from 'utils';
import { AlertsProvider } from 'providers';

export default function withAlerts(WrappedComponent) {
  const WithAlerts = (props) => (
      <AlertsProvider>
        <WrappedComponent {...props} />
      </AlertsProvider>
    )
  WithAlerts.displayName = `WithAlerts(${getDisplayName(WrappedComponent)})`;
  return WithAlerts;
}
